/**
 *
 * WidgetEnps
 *
 */

import React, { Fragment } from "react"
import { Doughnut } from "react-chartjs-2"
import { Popover } from "antd"
import { isEqual } from "lodash"
import Carita_roja from "../../images/Carita_roja.svg"
import Carita_amarilla from "../../images/Carita_amarilla.svg"
import Carita_verde from "../../images/Carita_verde.svg"
import imgenps from "../../images/enpsimg.svg"
import imgenps10 from "../../images/enps10img.svg"
import "./index.less"
import { QuestionCircleFilled } from "@ant-design/icons"
import { validate } from "../../utils/functions"
/* eslint-disable react/prefer-stateless-function */
class WidgetEnps extends React.Component {
  state = {
    climeChart: {
      data: {
        datasets: [
          {
            data: [30, 60, 10],
            borderWidth: 0,
            backgroundColor: ["#5ad0b7", "#f9bf78", "#e88282"],
            weight: 0.3,
          },
        ],
        text: "26%",
      },
      options: {
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        responsive: false,
        tooltips: { enabled: false },
        legend: { display: false },
      },
    },
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.data, this.props.data)) {
      this.setData(nextProps)
    }
  }

  componentDidMount() {
    if (this.props.data) {
      this.setData(this.props)
    }
  }

  setData = (nextProps) => {
    const { climeChart } = this.state
    climeChart.data.datasets[0].data = [
      parseInt(nextProps.data.value, 0),
      parseInt(nextProps.data.value_middle, 0),
      parseInt(nextProps.data.value_low, 0),
    ]
    climeChart.data.text =
      nextProps.data.value_enps == 0
        ? "N/A"
        : `${parseInt(nextProps.data.value_enps, 10)}%`
    this.setState({ climeChart })
  }

  render() {
    const { data } = this.props
    return (
      <Fragment>
        <div className="WidgetEnps-header subtitle_section">
          <span style={{ fontWeight: 400 }}>Distribución</span> <b>eNPS</b>
          <Popover
            placement="bottom"
            overlayClassName="popover-title-center"
            title="Employee Net Promoter Score (Recomendación)"
            trigger="hover"
            content={
              <div style={{ maxWidth: 532 }}>
                {validate.exist(data) && data.enps_scale === 5 && (
                  <p style={{ textAlign: "justify" }}>
                    La pregunta <b>eNPS</b> (Employee Net Promoter Score) es un
                    indicador que mide la fidelidad y el engagement de los
                    colaboradores con su organización. Se basa en una pregunta
                    en la que los colaboradores tienen que marcar, del 0 al 5,
                    qué tanto recomendarían a la empresa como lugar de trabajo a
                    sus amigos o familiares.
                  </p>
                )}
                {validate.exist(data) && data.enps_scale === 10 && (
                  <p style={{ textAlign: "justify" }}>
                    La pregunta <b>eNPS</b> (Employee Net Promoter Score) es un
                    indicador que mide la fidelidad y el engagement de los
                    colaboradores con su organización. Se basa en una pregunta
                    en la que los colaboradores tienen que marcar, del 0 al 10,
                    qué tanto recomendarían a la empresa como lugar de trabajo a
                    sus amigos o familiares.
                  </p>
                )}
                <p className="text-left">
                  <b>¿Cómo se calcula?</b>
                </p>
                <div className="eNPSToolTip__formula">
                  <span className="nps-label">eNPS</span>
                  <span> = </span>
                  <span style={{ color: "#5ad0b7" }}>Promotores(%)</span>
                  <span> - </span>
                  <span style={{ color: "#e88282" }}>Detractores(%)</span>
                </div>
                <div style={{ margin: "20px 0" }}>
                  {validate.exist(data) && data.enps_scale === 5 && (
                    <img src={imgenps} width="100%" />
                  )}
                  {validate.exist(data) && data.enps_scale === 10 && (
                    <img src={imgenps10} width="100%" />
                  )}
                </div>
              </div>
            }>
            {" "}
            <QuestionCircleFilled
              style={{
                color: "#D8D8D8",
                verticalAlign: "baseline",
                fontSize: "14px",
              }}
            />
          </Popover>
        </div>
        <div className="WidgetEnps-body" style={{ position: "relative" }}>
          {false && ( // no se mostrará - 24 octubre 2019
            <Fragment>
              <div className="ReportsHome-enps-empty-smooth" />
              <div
                className="ReportsHome-enps-empty"
                style={{ position: "absolute", width: "100%", top: 26 }}>
                <div
                  className="ReportsHome-enps-empty-Text"
                  style={{ width: "100%", top: 0, left: 0 }}>
                  Aún no es posible determinar la <b>distribución eNPS</b>.
                  <br /> <br />
                  Se requiere de una tasa de respuesta mínima de 10%.
                </div>
              </div>
            </Fragment>
          )}
          <div className="leyenda">
            <div className="leyenda__rojo">
              <div>
                <img src={Carita_roja} />
                <span className="porcentaje">
                  {data.value_low_visible || "-"}
                </span>
              </div>
              <div className="nombre">
                Detractores{" "}
                <span className="total">({data.employees_low || 0})</span>
              </div>
            </div>
            <div className="leyenda__amarillo">
              <div>
                <img src={Carita_amarilla} />
                <span className="porcentaje">
                  {" "}
                  {data.value_middle_visible || "-"}
                </span>
              </div>
              <div className="nombre">
                Pasivos{" "}
                <span className="total">({data.employees_middle || 0})</span>
              </div>
            </div>
            <div className="leyenda__verde">
              <div>
                <img src={Carita_verde} />
                <span className="porcentaje">{data.value_visible || "-"}</span>
              </div>
              <div className="nombre">
                Promotores{" "}
                <span className="total">({data.employees_top || 0})</span>
              </div>
            </div>
          </div>
          <div className="WidgetEnps-body-chart">
            <Doughnut
              data={this.state.climeChart.data}
              options={this.state.climeChart.options}
              width={105}
            />
            <div className="WidgetEnps-body-chart-text">
              {this.state.climeChart.data.text}
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

WidgetEnps.propTypes = {}

export default WidgetEnps
